export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export interface SortOption {
  label: string
  value: { field: string; order: SortOrder }
}

export enum OrderStatus {
  All = 0,
  NewOrder,
  InProgress,
  Shipped,
  PartiallyShipped,
  Cancelled,
  OnHold,
  NotPaid,
  Refund,
  Delivered,
  InProduction
}

export const DEFAULT_SORT_FIELD = 'created_at'
export const DEFAULT_SORT_ORDER: SortOrder = SortOrder.Desc

enum PaymentStatus {
  Pending = 'pending',
  Paid = 'paid',
  Failed = 'failed'
}

type Severity = 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined

export function getOrderStatus(status: number): string {
  switch (status) {
    case OrderStatus.NewOrder:
      return 'New Order'
    case OrderStatus.InProgress:
      return 'In Progress'
    case OrderStatus.Shipped:
      return 'Shipped'
    case OrderStatus.PartiallyShipped:
      return 'Partially Shipped'
    case OrderStatus.Cancelled:
      return 'Cancelled'
    case OrderStatus.OnHold:
      return 'On Hold'
    case OrderStatus.NotPaid:
      return 'Not Paid'
    case OrderStatus.Refund:
      return 'Refund'
    case OrderStatus.Delivered:
      return 'Delivered'
    case OrderStatus.InProduction:
      return 'In Production'
    default:
      return 'Pending'
  }
}

export function getOrderStatusSeverity(status: number): Severity {
  switch (status) {
    case OrderStatus.NewOrder:
      return 'info'
    case OrderStatus.InProgress:
      return 'warn'
    case OrderStatus.Shipped:
    case OrderStatus.Delivered:
      return 'success'
    case OrderStatus.PartiallyShipped:
    case OrderStatus.InProduction:
      return 'warn'
    case OrderStatus.Cancelled:
      return 'danger'
    case OrderStatus.OnHold:
      return 'warn'
    case OrderStatus.NotPaid:
      return 'danger'
    case OrderStatus.Refund:
      return 'info'
    default:
      return 'info'
  }
}

export function getPaymentStatusSeverity(paymentStatus: PaymentStatus | string): Severity {
  switch (paymentStatus.toLowerCase()) {
    case PaymentStatus.Pending:
      return 'warn'
    case PaymentStatus.Paid:
      return 'success'
    case PaymentStatus.Failed:
      return 'danger'
    default:
      return 'info'
  }
}
